import React, {useCallback, useContext, useEffect, useState} from 'react';
import {useRouter} from "next/router";

const StarterModelContext = React.createContext<boolean>(false);

export function useStarterModel() {
  return useContext(StarterModelContext);
}

export default function StarterModelProvider({children}: any) {
  const [isStarterModel, setStarterModel] = useState(false);
  const router = useRouter();
  const {projectId} = router.query;

  useEffect(() => {
    if (projectId === "starters") {
      setStarterModel(true);
    } else {
      setStarterModel(false);
    }
  }, [projectId])

  return (
    <StarterModelContext.Provider value={isStarterModel}>
      {children}
    </StarterModelContext.Provider>
  );
}
